import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["projectInput", "availableInput"];

  updateTypes(){
    let selectedIndex = this.projectInputTarget.selectedIndex;

    if (selectedIndex === 0 || this.projectInputTarget.value === "") {
      this.availableInputTarget.innerHTML = "<option value=''>Choose a type</option>";
      return;
    }

    let available_options = JSON.parse(this.projectInputTarget.options[selectedIndex].dataset.availableTypes);
    this.availableInputTarget.innerHTML = "";
    for (let option of available_options){
      const key = Object.keys(option)[0];
      const value = option[key];
      this.availableInputTarget.insertAdjacentHTML("beforeend", `<option value="${value}">${key}</option>`);
    }
  }
}
